export const APP_STATE_KEY = "_APP_STATE_KEY_";

export const defaultAppState = {
  staffId: undefined,
  initialized: true,
};
